import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { StandardDropdown } from '~shared-components/components'
import { useAllowedLanguages } from '~shared-components/hooks/useAllowedLanguages'
import { useTranslations } from '~shared-components/hooks/useTranslations'
import { TranslationsSelector } from '~shared-components/redux/selectors/translations.selector'
import { TranslationMap } from '~shared-components/translations/default'
import { SupportedLanguage } from '~shared-components/utils/enums'

interface LanguageDropdownProps {
  disabled?: boolean
  onChange: (language: SupportedLanguage) => Promise<void> | void
  placement?: 'top' | 'bottom'
  showOnlyCommonLanguage?: boolean
  value?: SupportedLanguage
}

export const LanguageDropdown: React.FC<LanguageDropdownProps> = ({
  disabled,
  onChange,
  placement,
  showOnlyCommonLanguage,
  value,
}) => {
  const allowedLanguages = useAllowedLanguages({ showOnlyCommonLanguage })
  const t = useTranslations()
  const currentLanguage = useSelector(TranslationsSelector.currentLanguage)
  const options = useMemo(
    () =>
      allowedLanguages.map(code => ({
        description: t(`isolanguage.${code}` as keyof TranslationMap),
        value: code,
      })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [allowedLanguages],
  )

  return (
    <StandardDropdown
      disabled={disabled || allowedLanguages.length <= 1}
      onOptionSelect={onChange}
      options={options}
      placement={placement}
      value={value !== undefined ? value : currentLanguage}
    />
  )
}
